import { Box } from '@mui/material';
import { GridInitialStatePremium } from '@mui/x-data-grid-premium/models/gridStatePremium';
import { Context, useMemo } from 'react';
import { TableDataPage } from 'shared/components';
import { ProductFilterEnum } from 'shared/constants';
import { ProvideTableData, createTableDataContext } from 'shared/providers/provideTableData';
import { GridColumns, TableDataContext } from 'shared/types';
import { TAddProductsData } from 'types/backend';
import { ProductFilters } from './productFilters';
import { ProductsToggle } from './productsToggle';

interface ProductsResolverProps {
    columnConfig: GridColumns<TAddProductsData>;
    productsContext?: Context<TableDataContext<TAddProductsData>>;
    name: string;
    alternateQueryPath?: string;
    title: string;
    hideExport?: boolean;
    productTabSelected: ProductFilterEnum;
}

export function ProductsResolver({
    columnConfig,
    productsContext,
    name,
    alternateQueryPath,
    title,
    hideExport = true,
    productTabSelected,
}: ProductsResolverProps) {
    const addProductsContext = useMemo(
        () => (productsContext ? productsContext : createTableDataContext<TAddProductsData>()),
        [productsContext]
    );

    const toolbarChildren: JSX.Element[] = [
        <Box key={'toolbar-space-filler-upper'} sx={{ flexGrow: 1 }} />,
        <ProductsToggle
            key={'products-toggle'}
            productTabSelected={productTabSelected}
            tableDataContext={addProductsContext}
        />,
        <ProductFilters key={'filters'} />,
    ];

    const defaultAddProductsConfig: {initialState?: GridInitialStatePremium} | undefined = {
        initialState: {
            pagination: {
                paginationModel: {
                    page: 0,
                    pageSize: 100,
                },
            }
        },
    }

    return (
        <ProvideTableData name={name} tableDataContext={addProductsContext} alternateQueryPath={alternateQueryPath} config={defaultAddProductsConfig}>
            <TableDataPage
                title={title}
                columnConfig={columnConfig}
                tableDataContext={addProductsContext}
                config={{
                    hideExport,
                }}
                customToolbarChildren={toolbarChildren}
            />
        </ProvideTableData>
    );
}
